export const initialState = {
  newUserIsVisible: false,
  currentUser: null,
  fetchMoreIsBusy: false,
  currentPageIndex: 0,
  searchedUsername: '',
  searchedPageName: '',
  sortKey: 'createdDate',
  sortDirection: 'desc',
};

export const types = {
  SET_NEW_USER_IS_VISIBLE: 'SET_NEW_USER_IS_VISIBLE',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_FETCH_MORE_IS_BUSY: 'SET_FETCH_MORE_IS_BUSY',
  SET_CURRENT_PAGE_INDEX: 'SET_CURRENT_PAGE_INDEX',
  SET_MULTI: 'SET_MULTI',
  SET_SEARCHED_USERNAME: 'SET_SEARCHED_USERNAME',
  SET_SEARCHED_PAGENAME: 'SET_SEARCHED_PAGENAME',
  SET_SORT_KEY: 'SET_SORT_KEY',
  SET_SORT_DIRECTION: 'SET_SORT_DIRECTION',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_NEW_USER_IS_VISIBLE:
      return { ...state, newUserIsVisible: payload };
    case types.SET_CURRENT_USER:
      return { ...state, currentUser: payload };
    case types.SET_FETCH_MORE_IS_BUSY:
      return { ...state, fetchMoreIsBusy: payload };
    case types.SET_CURRENT_PAGE_INDEX:
      return { ...state, currentPageIndex: payload };
    case types.SET_SEARCHED_USERNAME:
      return { ...state, searchedUsername: payload };
    case types.SET_SEARCHED_PAGENAME:
      return { ...state, searchedPageName: payload };
    case types.SET_SORT_KEY:
      return { ...state, sortKey: payload };
    case types.SET_SORT_DIRECTION:
      return { ...state, sortDirection: payload };
    case types.SET_MULTI:
      return { ...state, ...payload };
    default:
      throw new Error();
  }
};
